function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_inverted_gefahr",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#F9F9F9",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  d: "M30.5615396,7.43962551 C31.1461535,8.02579285 31.1461535,8.97959066 30.5615396,9.565758 L26.12,14.018 L30.5244245,18.4342309 C31.1090677,19.0204278 31.1090383,19.9741961 30.5244245,20.5603634 C29.9398107,21.1465308 28.9885407,21.1465308 28.4039269,20.5603634 L24,16.144 L19.5960731,20.5603634 C19.0114299,21.1465603 18.0601893,21.1465308 17.4755755,20.5603634 C16.8909617,19.9741961 16.8909617,19.0203983 17.4755755,18.4342309 L21.879,14.018 L17.4384604,9.565758 C16.8538465,8.97959066 16.8538465,8.02579285 17.4384604,7.43962551 C18.0230742,6.85345816 18.9743442,6.85345816 19.558958,7.43962551 L24,11.892 L28.441042,7.43962551 C29.0256558,6.85345816 29.9769258,6.85345816 30.5615396,7.43962551 Z",
  id: "Path",
  fill: "#FB5607"
}));

var SvgIcGrayBadgeDanger = function SvgIcGrayBadgeDanger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcGrayBadgeDanger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_gray_badge_danger.85c7e980.svg";
export { ForwardRef as ReactComponent };